<template>
	<div class="container">
		<div class="progress-bar mb-4">
			<div class="progress-bar-fill" :style="`width: ${progress * 100}%`"/>
		</div>
		<transition mode="out-in" name="fade">
			<div v-if="currentCasePage">
				<page-component-container
						:breadcrumbUrl="breadcrumbUrl"
						:description="description"
						:leftComponent="leftComponent"
						:leftComponentOptions="leftComponentOptions"
						:rightComponent="rightComponent"
						:rightComponentOptions="rightComponentOptions"
						:title="title"
						:useTransitions="useTransitions"
				/>
			</div>
		</transition>
	</div>
</template>

<script>
    import GamePhase from '@/enum/GamePhase'
    import PageComponentContainer from '@/components/page-components/page-component-container';
    import {mapGetters} from 'vuex'
    import * as MutationTypes from '@/store/mutation-types'
    import {getTeacherUrl} from '@/utils/UrlUtil'

    export default {
		name: 'page-controller',
		components: {
			PageComponentContainer
		},
		props: {
			redirectToLobby: {
				type: Boolean,
				required: false,
				default: true
			},
			useTransitions: {
				type: Boolean,
				required: false,
				default: true
			}
		},
		mounted() {
			if (this.redirectToLobby && (!this.currentCase || !this.$gameClient.isPhase([GamePhase.Pages]))) {
				console.log('Current case missing or $gameClient is not in the Pages phase - going back to lobby')

				// The game is not at the right point right now.. let's revert the user to the lobby screen
				this.$router.push(getTeacherUrl('lobby'))
			} else {

				this.$store.commit(MutationTypes.SET_NAVIGATION_GUARD_ENABLED, true);
			}
		},
		computed: {
			...mapGetters({
				currentCase: 'getCurrentCase',
				currentPageIndex: 'getCurrentPageIndex'
			}),
			breadcrumbUrl() {
				return getTeacherUrl('lobby');
			},
			currentCasePage() {
				if (this.currentCase && this.currentCase.pages && this.currentCase.pages.length > this.currentPageIndex) {
					return this.currentCase.pages[this.currentPageIndex];
				} else {
					return null;
				}
			},
			title() {
				if (!this.currentCasePage) {
					return null;
				}

				return this.currentCasePage.title || ''
			},
			description() {
				if (!this.currentCasePage) {
					return null;
				}

				return this.currentCasePage.description || ''
			},
			left() {
				if (!this.currentCasePage) {
					return null;
				}

				return this.currentCasePage.components.hasOwnProperty(
					'left') ? this.currentCasePage.components.left : null;
			},
			leftComponent() {
				return this.left ? this.left.component : null;
			},
			leftComponentOptions() {
				if (!this.left) {
					return null;
				}

				if (this.left.options instanceof Array) {
					return null;
				}

				return this.left.options;
			},
			right() {
				if (!this.currentCasePage) {
					return null;
				}

				return this.currentCasePage.components.hasOwnProperty(
					'right') ? this.currentCasePage.components.right : null;
			},
			rightComponent() {
				return this.right ? this.right.component : null;
			},
			rightComponentOptions() {
				if (!this.right) {
					return null;
				}

				if (this.right.options instanceof Array) {
					return null;
				}

				return this.right.options;
			},
			progress() {
				return (this.currentPageIndex + 1) / this.currentCase.pages.length;
			}
		}
	}
</script>

<style lang="less" scoped>
	@import "~@less/variables.less";

	.progress-bar {
		height: 10px;
		width: 100%;
		position: relative;
		background-color: @grey-light;
	}

	.progress-bar-fill {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		background-color: @roskilde-blue;
		transition: width 0.5s ease-out;
	}
</style>
